module.exports = __webpack_public_path__ + "static/projectManagement-e66346b7bac3e7ad08c6d61eac2c9cdd.jpg";